import React from "react"
import { useTranslation } from "react-i18next";

//MUI
import LanguageIcon from "@mui/icons-material/Language";

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";

type InfoPaneUrlActionButtonProps = {
  url?: string;
}

const InfoPaneUrlActionButton = (props: InfoPaneUrlActionButtonProps) => {

    const { url, } = props;
  
    return(
        <InfoPaneActionButton
          title_ttoken={"buttons.url"}
          icon={<LanguageIcon sx={{transform: "scale(0.8)"}} color="primary" fontSize="large"/>}
          onClick={(evt) => {window.open(url,"_blank")}}
        />
    )

}

export default InfoPaneUrlActionButton;